import axios from 'axios'

export default axios.create({
    baseURL: '',
    timeout: 10000
})

const apiUrl = 'https://jisunews.market.alicloudapi.com'
const headers = {
    "Authorization": "APPCODE " + "d3639a87f67c48e7a10c1c3f1fc3e5b4",
    "Content-Type": "application/json; charset=UTF-8"
}

export function queryNewsList(channel, num) {
    const params = {
        channel,
        num,
        start: "0"
    }
    return axios.get(`${apiUrl}/news/get`, { headers, params });
}

export function queryZs() {
    const codes = ["sh000001", "sz399001", "sz399006", "sh000688", "bj899050"];
    return axios.get("https://qt.gtimg.cn/q=" + codes.join(",") + "&_=" + Math.random());
}


// WEBPACK FOOTER //
// ./src/api/index.js